import * as React from 'react';
import { SVGProps } from 'react';

const SvgFactory = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#factory_svg__a)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.5 4.25a.75.75 0 0 0-.75.75v14.5c0 .414.336.75.75.75h18a.75.75 0 0 0 .75-.75v-12a.75.75 0 0 0-1.085-.67L14.25 9.785V7.5a.75.75 0 0 0-1.085-.67L7.25 9.785V5a.75.75 0 0 0-.75-.75h-4Zm.75 14.5v-13h2.5V11a.75.75 0 0 0 1.085.67l5.915-2.956V11a.75.75 0 0 0 1.085.67l5.915-2.956V18.75h-2.5V14.5a.75.75 0 0 0-.75-.75H13a.75.75 0 0 0-.75.75v4.25h-9Zm10.5 0h2v-3.5h-2v3.5Z'
        fill='#000'
      />
    </g>
    <defs>
      <clipPath id='factory_svg__a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
);

export default SvgFactory;
